import axios from 'axios';
const accessToken = localStorage.getItem('accessToken');
axios.defaults.headers.common = { Authorization: `Bearer ${accessToken}` };
export default axios;
